import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { archivedKeys } from "./useFetchArchives";
import { deleteEmployee, unarchiveEmployee } from "src/redux/api/_hr.api";

export const useUnarchiveEmployeeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (employeeId: number) => unarchiveEmployee(employeeId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: archivedKeys.all });
      toast.success("Employee Unarchived Successfully");
    },
    onError: (error) => {
      toast.error("Failed to Unarchive Employee");
      console.error(error);
    },
  });
};

export const useDeleteEmployeeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (employeeId: number) => deleteEmployee(employeeId),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: archivedKeys.all });
      toast.success("Employee Deleted Successfully");
    },
    onError: (error) => {
      toast.error("Failed to Delete Employee");
      console.error(error);
    },
  });
};
